import { axios } from '@Root/API'

export const deleteFieldMapping = id => {
  return axios.delete(`cognito-form-field-mappings/${id}`)
}
